module.exports = __webpack_public_path__ + "static/media/independents.b76eea57.png";